import { Leads } from "../../../interfaces/Leads";
import { PostagemData } from "../../ViewGerenciarPostagens/Interface/PostagemData";
import { Informacao } from "../Interface/Informacao";
import { Interesse } from "../Interface/Interesse";
import { SMS } from "../Interface/Sms";

export const handleNext = async (
  activeStep: number,
  setActiveStep: (step: number) => void,
  stepsStatus: Array<"wait" | "process" | "finish" | "error">,
  setStepsStatus: (
    step: Array<"wait" | "process" | "finish" | "error">
  ) => void,
  setBloquearBtn: (btn: boolean) => void,
  formData: Partial<Leads>,
  enviaSms: (data: Partial<SMS>) => Promise<boolean>,
  formSms: Partial<SMS>,
  verificaSms: (data: SMS) => Promise<boolean>,
  formInteresse: Partial<Interesse>,
  formMaisInteresse: Partial<Interesse>,
  formInfo: Partial<Informacao>,
  formMaisInfo: Partial<Informacao>,
  cadastrar: (data: PostagemData) => Promise<boolean>,
  showSuccess: (msg: string) => void,
  showWarning: (msg: string) => void,
  showError: (msg: string) => void,
  renderInteresse: number,
  setRenderInteresse: (render: number) => void
) => {
  const updatedStatus = [...stepsStatus];
  switch (activeStep) {
    case 0:
      try {
        console.log(formData);
        setBloquearBtn(true); // evitar múltiplos cliques
        const sms = await enviaSms(formData);

        if (!sms) {
          updatedStatus[activeStep] = "error";
          setStepsStatus(updatedStatus);
          showError(
            "Erro ao enviar SMS. Verifique seu número e tente novamente."
          );
          setBloquearBtn(false); // desbloqueia após erro
          return;
        }

        updatedStatus[activeStep] = "finish";
        updatedStatus[activeStep + 1] = "process";
        setStepsStatus(updatedStatus);
        showSuccess("SMS enviado com sucesso! Verifique seu celular.");
        setActiveStep(activeStep + 1);
      } catch (error) {
        const mensagemErro =
          error?.response?.data?.message || // NestJS ou backend estruturado
          "Erro inesperado. Por favor, tente novamente.";

        showError(mensagemErro);
        updatedStatus[activeStep] = "error";
        setStepsStatus(updatedStatus);
        setBloquearBtn(false); // desbloqueia após erro
      }

      break;

    case 1:
      try {
        const data = {
          celular: formData.celular ?? "",
          codigo: formSms?.codigo ?? "", // garante que codigo seja string sempre
        };

       

        const confirmarSms = await verificaSms(data);

        if (!confirmarSms) {
          updatedStatus[activeStep] = "error"; // finaliza a etapa atual com error
          showError("Código inválido ou expirado.Por favor, reenvie o código");
           
          setStepsStatus(updatedStatus);
          return;
        }
        updatedStatus[activeStep] = "finish"; // finaliza a etapa atual
        updatedStatus[activeStep + 1] = "process"; // Etapa posterior em processo
        showSuccess("Número verificado com sucesso!");
        setStepsStatus(updatedStatus);
        setBloquearBtn(true);

        setActiveStep(activeStep + 1);
      } catch (error) {
        console.error("Erro na verificação do SMS:", error);
        showError(
          "Erro inesperado. Por favor, tente novamente ou entre em contato com os administradores."
        );
        updatedStatus[activeStep] = "error";
        setStepsStatus(updatedStatus);
      }

      break;

    case 2:
      setBloquearBtn(true);
      if (renderInteresse === 1) {
        setRenderInteresse(renderInteresse + 1);
        return;
      }
      updatedStatus[activeStep] = "finish"; // finaliza a etapa atual
      updatedStatus[activeStep + 1] = "process"; // Etapa posterior em processo
      setStepsStatus(updatedStatus);

      setActiveStep(activeStep + 1);
      break;

    case 3:
      updatedStatus[activeStep] = "finish"; // finaliza a etapa atual
      updatedStatus[activeStep + 1] = "process"; // Etapa posterior em processo
      setStepsStatus(updatedStatus);
      setBloquearBtn(true);
      setActiveStep(activeStep + 1);
      break;
    case 4:
      try {
        const postagemData = {
          nome: formData.nome ?? "",
          celular: formData.celular ?? "",
          idEmpreendimento: formInfo.idEmpreendimento ?? 0,
          tipoInteresse: formInteresse.tipoInteresse ?? "",
          troca: formInteresse.troca ?? 0,
          aluguel: formInteresse.aluguel ?? 0,
          compra: formInteresse.compra ?? 0,
          venda: formInteresse.venda ?? 0,
          dataIni: formMaisInfo.dataIni ?? "",
          dataFim: formMaisInfo.dataFim ?? "",
          dataDivulgacao: new Date().toISOString(),
          fonte: "Postagem",
          grupo: "Multicotas",
          active: 1,
        };

        const cadastrarPostagem = await cadastrar(postagemData);

        if (!cadastrarPostagem) {
          updatedStatus[activeStep] = "error"; // finaliza a etapa atual com error
          showError(
            "Não foi possível finalizar. Por favor revise os campos e tente novamente."
          );
          setStepsStatus(updatedStatus);
          return;
        }

        updatedStatus[activeStep] = "finish"; // finaliza a etapa atual
        updatedStatus[activeStep + 1] = "process"; // Etapa posterior em processo
        setStepsStatus(updatedStatus);
        setActiveStep(activeStep + 1);
      } catch (error) {
        console.error("Erro ao cadastrar postagem:", error);
        showError(
          "Erro inesperado. Por favor, tente novamente ou entre em contato com os administradores."
        );
        updatedStatus[activeStep] = "error";
        setStepsStatus(updatedStatus);
      }

      break;
    case 5:
      window.location.reload();
  }
};
